import { hookUtils } from '@pukka/common/utils';
import { MdOutlineKeyboardBackspace } from 'react-icons/md';
import { twMerge } from 'tailwind-merge';
import { useLockedBody } from 'usehooks-ts';

import styles from './container.module.css';

interface DrawerContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  readonly open: boolean;
  readonly title: string;
  readonly children: React.ReactNode;
  readonly onClose: () => void;
}

function DrawerContainer({ children, className, open, title, onClose, ...props }: DrawerContainerProps) {
  const isMobile = hookUtils.useIsMobile();

  useLockedBody(isMobile && open, 'root');

  const desktopClassNames = twMerge(styles.content, 'relative h-full transition-all', !open ? 'w-0' : 'w-2/4', className);
  const mobileClassNames = twMerge('fixed inset-x-0 z-50', open ? 'inset-y-0' : '-bottom-full', className);

  return (
    <div className={isMobile ? mobileClassNames : desktopClassNames} {...props}>
      {isMobile && (
        <div className="relative flex h-14 items-center justify-center bg-blue-500 px-4 font-medium text-white">
          <button type="button" aria-label="button to close drawer h-full" className="absolute left-4" onClick={onClose}>
            <MdOutlineKeyboardBackspace color="white" size={24} />
          </button>
          {title}
        </div>
      )}
      {children}
    </div>
  );
}

export { DrawerContainer };
